import {EmailDto} from "./email.dto";
import {nonBlank} from "../../libs/utils/epic.utils";

export class UserDto {

  public id!: string;
  public enabled!: boolean;
  public languageCode!: string;
  public countryCode!: string;
  public timezone!: string;
  public firstname!: string;
  public lastname!: string;
  public emails: EmailDto[] = [];

  constructor(init?: Partial<UserDto>) {
    Object.assign(this, init);
    if (init?.emails) {
      this.emails = init.emails.map((e) => new EmailDto(e));
    }
  }

  public getPrimeEmail(): EmailDto | null {
    const emails = this.emails.filter((e) => e.prime);
    return emails.length > 0 ? emails[0] : null;
  }

  public getUsername(): string | undefined {
    if (this.hasFirstname()) {
      return this.firstname;
    } else if (this.getPrimeEmail()?.email) {
      return this.getPrimeEmail()?.email;
    }
    return '';
  }

  public hasFirstname(): boolean {
    return nonBlank(this.firstname);
  }

  public getFullName(): string {
    const names = [];
    if (nonBlank(this.firstname)) {
      names.push(this.firstname);
    }
    if (nonBlank(this.lastname)) {
      names.push(this.lastname);
    }
    return names.join(' ');
  }
}
